import React from 'react'
import { Trans } from 'react-i18next'

import { SvgImage } from 'components/SvgImage'

import trustPilotLogo from 'assets/images/sprite/trustpilot-logo.svg'

import { StyledTrustPilotBannerVariant2 as S } from './TrustPilotBannerVar2.styles'

export const TrustPilotBannerVariant2 = () => {
  return (
    <S.Container>
      <S.Content>
        <S.BoldText>
          <Trans i18nKey="onboarding.selectGenderKarma.trustpilot2.4point9" />
        </S.BoldText>
        <SvgImage svg={trustPilotLogo} width={64} />
      </S.Content>

      <S.Text>
        <Trans i18nKey="onboarding.selectGenderKarma.trustpilot2.believersGrow" />
      </S.Text>
    </S.Container>
  )
}
